module.exports = __webpack_public_path__ + "static/media/batmanclassic.2ace2ed6.mp3";